[
  {
    "id": "rivergate_chart_roads",
    "factionId": "humans",
    "locationId": "rivergate",
    "label": "Study the Road-Wardens' Maps — chart the roads beyond the heartland",
    "dialogueId": "rivergate_chart_roads",
    "costDays": 2,
    "effects": { "grantKnowledge": ["roads_charted"] },
    "hiddenWhenKnowledge": ["roads_charted"]
  },

  {
    "id": "stonehall_introduce",
    "factionId": "dwarves",
    "locationId": "stonehall",
    "label": "Present yourself to Thane Durn",
    "dialogueId": "stonehall_introduce",
    "effects": { "raiseTrust": { "factionId": "dwarves", "level": "recognized" }, "grantKnowledge": ["met_dwarves"] },
    "hiddenWhenTrustAtLeast": { "factionId": "dwarves", "level": "recognized" }
  },
  {
    "id": "stonehall_giant_road",
    "factionId": "dwarves",
    "locationId": "stonehall",
    "label": "Ask the Thane about the passes into Colossus Vale",
    "dialogueId": "stonehall_giant_road",
    "requires": { "trust": { "factionId": "dwarves", "level": "recognized" } },
    "effects": { "grantKnowledge": ["giants_road_known"] },
    "hiddenWhenKnowledge": ["giants_road_known"]
  },
  {
    "id": "emberforge_broker_feud",
    "factionId": "dwarves",
    "locationId": "emberforge",
    "label": "Broker the reconciliation between Stonehall and Emberforge",
    "dialogueId": "emberforge_broker_feud",
    "costDays": 2,
    "shortcut": {
      "knowledgeAny": ["dwarves_feud_settled"],
      "costDays": 0,
      "note": "You have settled the Stonehall–Emberforge feud in a past life, and the exact words that ended it come back to you unbidden."
    },
    "requires": { "trust": { "factionId": "dwarves", "level": "recognized" }, "ability": { "abilityId": "diplomacy", "level": "beginner" } },
    "effects": { "grantKnowledge": ["dwarves_feud_settled"], "setFlags": ["dwarves_conflict_resolved"] },
    "hiddenWhenFlags": ["dwarves_conflict_resolved"],
    "lockedHint": "The forge-city and the Thane's hall have not spoken in a generation. Settling it will take at least the confidence of a trained negotiator — locked: requires Diplomacy (beginner) and Thane Durn's recognition."
  },
  {
    "id": "stonehall_earn_trust",
    "factionId": "dwarves",
    "locationId": "stonehall",
    "label": "Ask the Thane to march the clans",
    "dialogueId": "stonehall_earn_trust",
    "requires": {
      "trust": { "factionId": "dwarves", "level": "recognized" },
      "flags": ["dwarves_conflict_resolved"],
      "ability": { "abilityId": "diplomacy", "level": "advanced" }
    },
    "effects": {
      "raiseTrust": { "factionId": "dwarves", "level": "trusted" },
      "grantKnowledge": ["dwarves_trusted"],
      "grantUnits": [{ "locationId": "stonehall", "unitId": "dwarven_shieldbearers", "count": 12 }]
    },
    "hiddenWhenTrustAtLeast": { "factionId": "dwarves", "level": "trusted" },
    "lockedHint": "The Thane will not march for a stranger, nor while the Emberforge feud festers — locked: requires the feud settled and Diplomacy (advanced)."
  },
  {
    "id": "stonehall_subject",
    "factionId": "dwarves",
    "locationId": "stonehall",
    "label": "Take command of the Dwarven host",
    "dialogueId": "stonehall_subject",
    "requires": {
      "trust": { "factionId": "dwarves", "level": "trusted" },
      "ability": { "abilityId": "diplomacy", "level": "master" }
    },
    "effects": {
      "raiseTrust": { "factionId": "dwarves", "level": "subjected" },
      "subjectFaction": "dwarves",
      "grantKnowledge": ["dwarves_subjected"],
      "grantUnits": [
        { "locationId": "stonehall", "unitId": "dwarven_hammerguard", "count": 10 },
        { "locationId": "stonehall", "unitId": "dwarven_cannoneers", "count": 8 }
      ]
    },
    "hiddenWhenTrustAtLeast": { "factionId": "dwarves", "level": "subjected" },
    "lockedHint": "To place the clans under your hand needs the full weight of a master diplomat — locked: requires the Thane's trust and Diplomacy (master)."
  },

  {
    "id": "thornwatch_introduce",
    "factionId": "wood_elves",
    "locationId": "thornwatch",
    "label": "Meet the Thornwatch rangers",
    "dialogueId": "thornwatch_introduce",
    "effects": { "raiseTrust": { "factionId": "wood_elves", "level": "recognized" }, "grantKnowledge": ["met_wood_elves"] },
    "hiddenWhenTrustAtLeast": { "factionId": "wood_elves", "level": "recognized" }
  },
  {
    "id": "greenveil_darkelf_road",
    "factionId": "wood_elves",
    "locationId": "greenveil",
    "label": "Have the rangers chart the way into the Nightweb",
    "dialogueId": "greenveil_darkelf_road",
    "requires": { "trust": { "factionId": "wood_elves", "level": "recognized" } },
    "effects": { "grantKnowledge": ["dark_elves_road_known"] },
    "hiddenWhenKnowledge": ["dark_elves_road_known"]
  },
  {
    "id": "elderroot_win_argument",
    "factionId": "wood_elves",
    "locationId": "elderroot_grove",
    "label": "Win the argument at Elderroot Grove",
    "dialogueId": "elderroot_win_argument",
    "costDays": 1,
    "shortcut": {
      "knowledgeAny": ["wood_elves_argument_won"],
      "costDays": 0,
      "note": "You have won this argument before, and you already know which precedent silences the grove."
    },
    "requires": { "trust": { "factionId": "wood_elves", "level": "recognized" }, "ability": { "abilityId": "history", "level": "beginner" } },
    "effects": { "grantKnowledge": ["wood_elves_argument_won"], "setFlags": ["wood_elves_conflict_resolved"] },
    "hiddenWhenFlags": ["wood_elves_conflict_resolved"],
    "lockedHint": "The elders answer to precedent and old grievance, not to urgency — locked: requires History (beginner) and the rangers' recognition."
  },
  {
    "id": "greenveil_earn_trust",
    "factionId": "wood_elves",
    "locationId": "greenveil",
    "label": "Ask Warden Sylvaine to march the rangers",
    "dialogueId": "greenveil_earn_trust",
    "requires": {
      "trust": { "factionId": "wood_elves", "level": "recognized" },
      "flags": ["wood_elves_conflict_resolved"],
      "ability": { "abilityId": "diplomacy", "level": "advanced" }
    },
    "effects": {
      "raiseTrust": { "factionId": "wood_elves", "level": "trusted" },
      "grantKnowledge": ["wood_elves_trusted"],
      "grantUnits": [
        { "locationId": "greenveil", "unitId": "wood_elf_pathfinders", "count": 10 },
        { "locationId": "greenveil", "unitId": "wood_elf_longbows", "count": 10 }
      ]
    },
    "hiddenWhenTrustAtLeast": { "factionId": "wood_elves", "level": "trusted" },
    "lockedHint": "Sylvaine will not move while Elderroot and Thornwatch pull against each other — locked: requires the grove's argument won and Diplomacy (advanced)."
  },
  {
    "id": "greenveil_subject",
    "factionId": "wood_elves",
    "locationId": "greenveil",
    "label": "Take command of the Wood Elf rangers",
    "dialogueId": "greenveil_subject",
    "requires": {
      "trust": { "factionId": "wood_elves", "level": "trusted" },
      "ability": { "abilityId": "diplomacy", "level": "master" }
    },
    "effects": {
      "raiseTrust": { "factionId": "wood_elves", "level": "subjected" },
      "subjectFaction": "wood_elves",
      "grantKnowledge": ["wood_elves_subjected"],
      "grantUnits": [{ "locationId": "greenveil", "unitId": "wood_elf_thornguard", "count": 10 }]
    },
    "hiddenWhenTrustAtLeast": { "factionId": "wood_elves", "level": "subjected" },
    "lockedHint": "The rangers follow no one lightly — locked: requires Sylvaine's trust and Diplomacy (master)."
  },

  {
    "id": "sevenfold_introduce",
    "factionId": "spellcasters",
    "locationId": "sevenfold_tower",
    "label": "Present yourself to Archmagister Vaeloth",
    "dialogueId": "sevenfold_introduce",
    "effects": { "raiseTrust": { "factionId": "spellcasters", "level": "recognized" }, "grantKnowledge": ["met_spellcasters"] },
    "hiddenWhenTrustAtLeast": { "factionId": "spellcasters", "level": "recognized" }
  },
  {
    "id": "rift_observatory_demon_road",
    "factionId": "spellcasters",
    "locationId": "rift_observatory",
    "label": "Have the Observatory fix the bearing to the Shattered Veil",
    "dialogueId": "rift_observatory_demon_road",
    "requires": { "trust": { "factionId": "spellcasters", "level": "recognized" } },
    "effects": { "grantKnowledge": ["demons_road_known"] },
    "hiddenWhenKnowledge": ["demons_road_known"]
  },
  {
    "id": "glass_library_reconcile_orders",
    "factionId": "spellcasters",
    "locationId": "glass_library",
    "label": "Reconcile the ritualists and the fire-handlers",
    "dialogueId": "glass_library_reconcile_orders",
    "costDays": 2,
    "shortcut": {
      "knowledgeAny": ["spellcasters_orders_reconciled"],
      "costDays": 0,
      "note": "You have reconciled the two orders once already, and you can lay the shared danger out for them without groping for it."
    },
    "requires": { "trust": { "factionId": "spellcasters", "level": "recognized" }, "ability": { "abilityId": "history", "level": "advanced" } },
    "effects": { "grantKnowledge": ["spellcasters_orders_reconciled"], "setFlags": ["spellcasters_conflict_resolved"] },
    "hiddenWhenFlags": ["spellcasters_conflict_resolved"],
    "lockedHint": "Each order believes the other will doom the world; only someone who can read the true history of the threat can show them they are describing the same danger — locked: requires History (advanced) and the Tower's recognition."
  },
  {
    "id": "sevenfold_earn_trust",
    "factionId": "spellcasters",
    "locationId": "sevenfold_tower",
    "label": "Ask the Tower to commit its orders",
    "dialogueId": "sevenfold_earn_trust",
    "requires": {
      "trust": { "factionId": "spellcasters", "level": "recognized" },
      "flags": ["spellcasters_conflict_resolved"],
      "ability": { "abilityId": "diplomacy", "level": "advanced" }
    },
    "effects": {
      "raiseTrust": { "factionId": "spellcasters", "level": "trusted" },
      "grantKnowledge": ["spellcasters_trusted"],
      "grantUnits": [
        { "locationId": "sevenfold_tower", "unitId": "ritual_mages", "count": 10 },
        { "locationId": "sevenfold_tower", "unitId": "flame_guard", "count": 10 }
      ]
    },
    "hiddenWhenTrustAtLeast": { "factionId": "spellcasters", "level": "trusted" },
    "lockedHint": "The Tower cannot commit to a war it cannot agree how to fight — locked: requires the two orders reconciled and Diplomacy (advanced)."
  },
  {
    "id": "sevenfold_subject",
    "factionId": "spellcasters",
    "locationId": "sevenfold_tower",
    "label": "Take command of the Sevenfold Tower",
    "dialogueId": "sevenfold_subject",
    "requires": {
      "trust": { "factionId": "spellcasters", "level": "trusted" },
      "ability": { "abilityId": "diplomacy", "level": "master" }
    },
    "effects": {
      "raiseTrust": { "factionId": "spellcasters", "level": "subjected" },
      "subjectFaction": "spellcasters",
      "grantKnowledge": ["spellcasters_subjected"],
      "grantUnits": [{ "locationId": "sevenfold_tower", "unitId": "storm_callers", "count": 10 }]
    },
    "hiddenWhenTrustAtLeast": { "factionId": "spellcasters", "level": "subjected" },
    "lockedHint": "Vaeloth answers to no crown without cause — locked: requires the Tower's trust and Diplomacy (master)."
  },

  {
    "id": "whispering_lake_introduce",
    "factionId": "good_spirits",
    "locationId": "whispering_lake",
    "label": "Seek the Pale Sister at the Whispering Lake",
    "dialogueId": "whispering_lake_introduce",
    "effects": { "raiseTrust": { "factionId": "good_spirits", "level": "recognized" }, "grantKnowledge": ["met_good_spirits"] },
    "hiddenWhenTrustAtLeast": { "factionId": "good_spirits", "level": "recognized" }
  },
  {
    "id": "whispering_lake_undead_road",
    "factionId": "good_spirits",
    "locationId": "whispering_lake",
    "label": "Ask the Sister the way to the Ashen Necropolis",
    "dialogueId": "whispering_lake_undead_road",
    "requires": { "trust": { "factionId": "good_spirits", "level": "recognized" } },
    "effects": { "grantKnowledge": ["undead_road_known"] },
    "hiddenWhenKnowledge": ["undead_road_known"]
  },
  {
    "id": "hall_ancestors_reconcile",
    "factionId": "good_spirits",
    "locationId": "hall_ancestors",
    "label": "Reconcile the ancestors and the living wardens",
    "dialogueId": "hall_ancestors_reconcile",
    "costDays": 1,
    "shortcut": {
      "knowledgeAny": ["good_spirits_reconciled"],
      "costDays": 0,
      "note": "You have brought the dead and the living to one voice here before, and the house remembers being at peace even if it does not remember you."
    },
    "requires": { "trust": { "factionId": "good_spirits", "level": "recognized" }, "ability": { "abilityId": "diplomacy", "level": "beginner" } },
    "effects": { "grantKnowledge": ["good_spirits_reconciled"], "setFlags": ["good_spirits_conflict_resolved"] },
    "hiddenWhenFlags": ["good_spirits_conflict_resolved"],
    "lockedHint": "The dead want vengeance and the living want mercy, and the Sister will not act until the house speaks with one voice — locked: requires Diplomacy (beginner) and the Sister's recognition."
  },
  {
    "id": "whispering_lake_earn_trust",
    "factionId": "good_spirits",
    "locationId": "whispering_lake",
    "label": "Ask the Sister to send the wardens to war",
    "dialogueId": "whispering_lake_earn_trust",
    "requires": {
      "trust": { "factionId": "good_spirits", "level": "recognized" },
      "flags": ["good_spirits_conflict_resolved"],
      "ability": { "abilityId": "diplomacy", "level": "advanced" }
    },
    "effects": {
      "raiseTrust": { "factionId": "good_spirits", "level": "trusted" },
      "grantKnowledge": ["good_spirits_trusted"],
      "grantUnits": [
        { "locationId": "whispering_lake", "unitId": "spirit_wardens", "count": 10 },
        { "locationId": "whispering_lake", "unitId": "ancestor_shades", "count": 8 }
      ]
    },
    "hiddenWhenTrustAtLeast": { "factionId": "good_spirits", "level": "trusted" },
    "lockedHint": "The Sister keeps her watch above any war until the house is of one mind — locked: requires the ancestors reconciled and Diplomacy (advanced)."
  },
  {
    "id": "whispering_lake_subject",
    "factionId": "good_spirits",
    "locationId": "whispering_lake",
    "label": "Take the Good Spirits into your cause",
    "dialogueId": "whispering_lake_subject",
    "requires": {
      "trust": { "factionId": "good_spirits", "level": "trusted" },
      "ability": { "abilityId": "diplomacy", "level": "master" }
    },
    "effects": {
      "raiseTrust": { "factionId": "good_spirits", "level": "subjected" },
      "subjectFaction": "good_spirits",
      "grantKnowledge": ["good_spirits_subjected"],
      "grantUnits": [{ "locationId": "whispering_lake", "unitId": "radiant_seraph", "count": 8 }]
    },
    "hiddenWhenTrustAtLeast": { "factionId": "good_spirits", "level": "subjected" },
    "lockedHint": "The dead do not enlist lightly — locked: requires the Sister's trust and Diplomacy (master)."
  },

  {
    "id": "camp_introduce",
    "factionId": "nomads",
    "locationId": "camp_seven_banners",
    "label": "Ride into the Camp of Seven Banners",
    "dialogueId": "camp_introduce",
    "effects": { "raiseTrust": { "factionId": "nomads", "level": "recognized" }, "grantKnowledge": ["met_nomads"] },
    "hiddenWhenTrustAtLeast": { "factionId": "nomads", "level": "recognized" }
  },
  {
    "id": "camp_troll_road",
    "factionId": "nomads",
    "locationId": "camp_seven_banners",
    "label": "Ask the riders the way into the Mire of Hunger",
    "dialogueId": "camp_troll_road",
    "requires": { "trust": { "factionId": "nomads", "level": "recognized" } },
    "effects": { "grantKnowledge": ["trolls_road_known"] },
    "hiddenWhenKnowledge": ["trolls_road_known"]
  },
  {
    "id": "windroad_broker_succession",
    "factionId": "nomads",
    "locationId": "windroad_market",
    "label": "Broker the succession of the Seven Banners",
    "dialogueId": "windroad_broker_succession",
    "costDays": 2,
    "shortcut": {
      "knowledgeAny": ["nomads_succession_brokered"],
      "costDays": 0,
      "note": "You have named this Khan before. You know which of the seven the other six will follow, and you say so at once."
    },
    "requires": { "trust": { "factionId": "nomads", "level": "recognized" }, "ability": { "abilityId": "diplomacy", "level": "beginner" } },
    "effects": { "grantKnowledge": ["nomads_succession_brokered"], "setFlags": ["nomads_conflict_resolved"] },
    "hiddenWhenFlags": ["nomads_conflict_resolved"],
    "lockedHint": "Seven clans and no Khan the other six will follow — settling it will take a diplomat's hand — locked: requires Diplomacy (beginner) and the clans' recognition."
  },
  {
    "id": "camp_earn_trust",
    "factionId": "nomads",
    "locationId": "camp_seven_banners",
    "label": "Ask Khan Aytolga to ride with you",
    "dialogueId": "camp_earn_trust",
    "requires": {
      "trust": { "factionId": "nomads", "level": "recognized" },
      "flags": ["nomads_conflict_resolved"],
      "ability": { "abilityId": "diplomacy", "level": "advanced" }
    },
    "effects": {
      "raiseTrust": { "factionId": "nomads", "level": "trusted" },
      "grantKnowledge": ["nomads_trusted"],
      "grantUnits": [
        { "locationId": "camp_seven_banners", "unitId": "nomad_horse_archers", "count": 14 },
        { "locationId": "camp_seven_banners", "unitId": "nomad_outriders", "count": 8 }
      ]
    },
    "hiddenWhenTrustAtLeast": { "factionId": "nomads", "level": "trusted" },
    "lockedHint": "An army that cannot choose a leader cannot lend one — locked: requires the succession brokered and Diplomacy (advanced)."
  },
  {
    "id": "camp_subject",
    "factionId": "nomads",
    "locationId": "camp_seven_banners",
    "label": "Take command of the Seven Banners",
    "dialogueId": "camp_subject",
    "requires": {
      "trust": { "factionId": "nomads", "level": "trusted" },
      "ability": { "abilityId": "diplomacy", "level": "master" }
    },
    "effects": {
      "raiseTrust": { "factionId": "nomads", "level": "subjected" },
      "subjectFaction": "nomads",
      "grantKnowledge": ["nomads_subjected"],
      "grantUnits": [{ "locationId": "camp_seven_banners", "unitId": "nomad_lancers", "count": 10 }]
    },
    "hiddenWhenTrustAtLeast": { "factionId": "nomads", "level": "subjected" },
    "lockedHint": "The Khan follows no crown he does not respect — locked: requires Aytolga's trust and Diplomacy (master)."
  },

  {
    "id": "cloudwood_dragon_road",
    "factionId": "high_elves",
    "locationId": "cloudwood_aerie",
    "label": "Have the watchers chart the road to Cinderpeak",
    "dialogueId": "cloudwood_dragon_road",
    "requires": { "trust": { "factionId": "high_elves", "level": "recognized" } },
    "effects": { "grantKnowledge": ["dragons_road_known"] },
    "hiddenWhenKnowledge": ["dragons_road_known"]
  },

  {
    "id": "blacktooth_assault",
    "factionId": "orcs",
    "locationId": "blacktooth_wastes",
    "label": "Storm the Blacktooth war-camp",
    "dialogueId": "assault_blacktooth",
    "startBattle": "blacktooth_stronghold_battle",
    "hiddenWhenFlags": ["orcs_stronghold_cleared"]
  },
  {
    "id": "blacktooth_expose",
    "factionId": "orcs",
    "locationId": "blacktooth_wastes",
    "label": "Expose the Necromancer's hand to the war-camp",
    "dialogueId": "blacktooth_expose",
    "requires": { "knowledge": ["orcs_had_outside_help"], "ability": { "abilityId": "history", "level": "advanced" } },
    "effects": { "grantCommandPoints": 5, "grantKnowledge": ["resolved_orcs"], "setFlags": ["orcs_stronghold_cleared", "orcs_redeemed"] },
    "hiddenWhenFlags": ["orcs_stronghold_cleared"],
    "lockedHint": "The orcs were armed and set on by something that opened a rift they could never have opened alone. Shown their strings, they might turn on the hand that pulled them — locked: requires proof of the outside help and History (advanced)."
  },

  {
    "id": "colossus_vale_assault",
    "factionId": "giants",
    "locationId": "colossus_vale",
    "label": "Assault Jarnsmiter's warband",
    "dialogueId": "assault_colossus_vale",
    "startBattle": "colossus_vale_battle",
    "hiddenWhenFlags": ["giants_stronghold_cleared"]
  },
  {
    "id": "colossus_vale_peace",
    "factionId": "giants",
    "locationId": "colossus_vale",
    "label": "Reopen the old dwarf–giant peace",
    "dialogueId": "colossus_vale_peace",
    "requires": { "subjectedFactions": ["dwarves"], "ability": { "abilityId": "history", "level": "advanced" } },
    "effects": { "grantCommandPoints": 6, "grantKnowledge": ["resolved_giants"], "setFlags": ["giants_stronghold_cleared", "giants_redeemed"] },
    "hiddenWhenFlags": ["giants_stronghold_cleared"],
    "lockedHint": "Dwarves and giants kept a peace once, before the debt of iron soured it. With the dwarves at your back and the old history in hand, the feud could be ended instead of the people — locked: requires the Dwarves subjected and History (advanced)."
  },

  {
    "id": "cinderpeak_assault",
    "factionId": "dragons",
    "locationId": "cinderpeak",
    "label": "Bring down the Ember of Cinderpeak",
    "dialogueId": "assault_cinderpeak",
    "startBattle": "cinderpeak_battle",
    "hiddenWhenFlags": ["dragons_stronghold_cleared"]
  },
  {
    "id": "cinderpeak_bargain",
    "factionId": "dragons",
    "locationId": "cinderpeak",
    "label": "Strike a cold bargain with Vharethyx",
    "dialogueId": "cinderpeak_bargain",
    "requires": { "ability": { "abilityId": "diplomacy", "level": "master" }, "knowledge": ["deadline_revealed"] },
    "effects": { "grantCommandPoints": 6, "grantKnowledge": ["resolved_dragons"], "setFlags": ["dragons_stronghold_cleared", "dragons_bargained"] },
    "hiddenWhenFlags": ["dragons_stronghold_cleared"],
    "lockedHint": "Dragons serve no one and burn only what is worth burning. A master's argument, and the truth that the sun itself is the stake, might buy Vharethyx out of the Necromancer's war entirely — locked: requires Diplomacy (master) and knowledge of the ritual's deadline."
  },

  {
    "id": "mire_hunger_assault",
    "factionId": "trolls",
    "locationId": "mire_hunger",
    "label": "Burn out the Mire of Hunger",
    "dialogueId": "assault_mire_hunger",
    "startBattle": "mire_hunger_battle",
    "hiddenWhenFlags": ["trolls_stronghold_cleared"]
  },
  {
    "id": "mire_hunger_pact",
    "factionId": "trolls",
    "locationId": "mire_hunger",
    "label": "Let the Nomads treat with the Mother of the Mire",
    "dialogueId": "mire_hunger_pact",
    "requires": { "subjectedFactions": ["nomads"], "ability": { "abilityId": "diplomacy", "level": "advanced" } },
    "effects": { "grantCommandPoints": 6, "grantKnowledge": ["resolved_trolls"], "setFlags": ["trolls_stronghold_cleared", "trolls_pacted"] },
    "hiddenWhenFlags": ["trolls_stronghold_cleared"],
    "lockedHint": "The trolls only ever hunted to be fed. With the Nomads' herds and the Nomads' word, a famine could be turned into a border rather than a battle — locked: requires the Nomads subjected and Diplomacy (advanced)."
  },

  {
    "id": "ashen_necropolis_assault",
    "factionId": "undead",
    "locationId": "ashen_necropolis",
    "label": "Throw down the anchor of the Ashen ground",
    "dialogueId": "assault_ashen_necropolis",
    "startBattle": "ashen_necropolis_battle",
    "hiddenWhenFlags": ["undead_stronghold_cleared"]
  },

  {
    "id": "nightweb_assault",
    "factionId": "dark_elves",
    "locationId": "nightweb_underrealm",
    "label": "Break the Nightweb in the open",
    "dialogueId": "assault_nightweb",
    "startBattle": "nightweb_battle",
    "hiddenWhenFlags": ["dark_elves_stronghold_cleared"]
  },
  {
    "id": "nightweb_buyout",
    "factionId": "dark_elves",
    "locationId": "nightweb_underrealm",
    "label": "Let the Wood Elves buy out their estranged kin",
    "dialogueId": "nightweb_buyout",
    "requires": { "subjectedFactions": ["wood_elves"], "ability": { "abilityId": "diplomacy", "level": "advanced" } },
    "effects": { "grantCommandPoints": 7, "grantKnowledge": ["resolved_dark_elves"], "setFlags": ["dark_elves_stronghold_cleared", "dark_elves_bought_out"] },
    "hiddenWhenFlags": ["dark_elves_stronghold_cleared"],
    "lockedHint": "The Dark Elves kill for coin and coercion, not conviction. With the Wood Elves speaking to their own estranged blood, Matron Vess could be bought out of the Necromancer's service — locked: requires the Wood Elves subjected and Diplomacy (advanced)."
  },

  {
    "id": "shattered_veil_assault",
    "factionId": "demon_spirits",
    "locationId": "shattered_veil",
    "label": "Seal the Shattered Veil at its anchor",
    "dialogueId": "assault_shattered_veil",
    "startBattle": "shattered_veil_battle",
    "hiddenWhenFlags": ["demon_spirits_stronghold_cleared"]
  },

  {
    "id": "ebon_citadel_behold",
    "factionId": "necromancer",
    "locationId": "ebon_citadel",
    "label": "Take the measure of the Ebon Citadel",
    "dialogueId": "ebon_citadel_behold",
    "effects": { "grantKnowledge": ["stood_before_ebon_citadel"] },
    "hiddenWhenKnowledge": ["stood_before_ebon_citadel"]
  },

  {
    "id": "ebon_citadel_open",
    "factionId": "necromancer",
    "locationId": "ebon_citadel",
    "label": "Open the citadel by the north cistern",
    "dialogueId": "ebon_citadel_open",
    "costDays": 1,
    "shortcut": {
      "knowledgeAny": ["breached_ebon_citadel"],
      "costDays": 0,
      "note": "You have gone in by the north cistern before. You do not have to find the grate again — you go straight to it."
    },
    "requires": { "knowledge": ["ebon_citadel_approach_known"] },
    "effects": { "grantKnowledge": ["breached_ebon_citadel"], "setFlags": ["ebon_citadel_breached"] },
    "hiddenWhenFlags": ["ebon_citadel_breached"],
    "lockedHint": "The gate is an army thick, and it was never the way in — every assault the world remembers died there. The other door is a flooded service passage under the north wall, reached by the road along the world's far edge — locked: requires sealing the Shattered Veil, which opens the approach to the citadel."
  },
  {
    "id": "ebon_citadel_assault",
    "factionId": "necromancer",
    "locationId": "ebon_citadel",
    "label": "Descend to the ritual chamber and end the Necromancer",
    "dialogueId": "assault_ebon_citadel",
    "startBattle": "ebon_citadel_battle",
    "requires": {
      "flags": [
        "ebon_citadel_breached",
        "orcs_stronghold_cleared",
        "giants_stronghold_cleared",
        "dragons_stronghold_cleared",
        "trolls_stronghold_cleared",
        "undead_stronghold_cleared",
        "dark_elves_stronghold_cleared",
        "demon_spirits_stronghold_cleared"
      ],
      "subjectedFactions": [
        "humans",
        "high_elves",
        "dwarves",
        "wood_elves",
        "spellcasters",
        "good_spirits",
        "nomads"
      ]
    },
    "hiddenWhenFlags": ["necromancer_defeated"],
    "lockedHint": "The way in is open, but the Necromancer sits behind five hundred days of work and every servant he armed to buy that time. Descending without the whole world at your back is only a slower death — locked: requires every allied realm under your command and every hostile stronghold thrown down this loop."
  }
]
